<template>
    <div>
        <img
            v-if="!(lazySrc === null)"
            :alt="alt"
            :src="lazySrc"
            @error="handleError"
            class="image"
            width="50"
            height="50">

        <div v-if="lazySrc === null" class="image">
            <b-icon-camera2 v-if="!lazySrc"></b-icon-camera2>
        </div>
    </div>
</template>
<script>
import {BIconCamera2} from "bootstrap-vue";

export default {
    name: 'ItemImage',
    components: {
        BIconCamera2
    },
    props: {
        alt: {
            required: true
        },
        src: {
            required: true
        },
    },
    data() {
        return {
            lazySrc: this.src
        }
    },
    created() {
        this.lazySrc = this.src;
    },
    methods: {
        handleError(event) {
            this.lazySrc = null;
        }
    }
}
</script>
<style scoped>
.image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background: white;
    border-radius: 3px;
    overflow: hidden;
}
</style>
